import * as React from "react";
import FormControl from "@mui/material/FormControl";
import OutlinedInput from "@mui/material/OutlinedInput";
import { IconButton } from "@mui/material";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "../Assests/Filter/Search.svg";
import CloseIcon from "../Assests/Dashboard/cross.svg";

const InputTextSearch = ({
  placeholder,
  value="",
  handleChange,
  handleSearchButton,
  handlefocus,
  onClear,
}) => {
  const hasValue = value && value?.trim()?.length > 0;

  const handleClear = (e) => {
    e.stopPropagation();
    if (onClear) {
      onClear();
    } else if (handleChange) {
      handleChange("");
    }
  };

  return (
    <>
      <FormControl fullWidth>
        <OutlinedInput
          size="small"
          placeholder={placeholder}
          value={value}
          onChange={(e) => {
            handleChange(e.target.value);
          }}
          onKeyDown={handlefocus}
          id="outlined-adornment-password"
          endAdornment={
            <InputAdornment position="end">
              {hasValue ? (
                <IconButton
                  sx={{ padding: "4px", marginRight: "4px" }}
                  onClick={handleClear}
                  aria-label="clear search"
                >
                  <img
                    src={CloseIcon}
                    alt="Clear"
                    style={{ width: "16px", height: "16px" }}
                  />
                </IconButton>
              ) : (
                handleSearchButton && (
                  <IconButton
                    sx={{ padding: "0" }}
                    onClick={() => {
                      handleSearchButton && handleSearchButton();
                    }}
                    aria-label="search"
                  >
                    <img src={SearchIcon} alt="Search" />
                  </IconButton>
                )
              )}
            </InputAdornment>
          }
          sx={{
            "&.Mui-focused": {
              outline: "none",
              boxShadow: "none",
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: "var(--qv-bd-000000, black)",
            },
            "& input:focus, & input:focus-visible": {
              outline: "none",
            },
            paddingRight: "14px",
          }}
        />
      </FormControl>
    </>
  );
};

export default InputTextSearch;
